var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Plus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.947,
    height: 16.947,
    viewBox: "0 0 16.947 16.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M333.049,261.31a8.474,8.474,0,1,1-8.474-8.474,8.474,8.474,0,0,1,8.474,8.474",
    transform: "translate(-316.102 -252.836)",
    fill: "#95a7c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M399.174,327.471h-2.908v-2.977a.7.7,0,1,0-1.4,0v2.977h-2.908a.7.7,0,0,0,0,1.4h2.908v2.839a.7.7,0,1,0,1.4,0v-2.839h2.908a.7.7,0,0,0,0-1.4",
    transform: "translate(-386.856 -319.642)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.5fc1462148e0a7a9099853c2de878d67.svg";
export { ForwardRef as ReactComponent };